<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Header con botón de regresar -->
      <div style="position: absolute;">
        <v-btn @click="$emit('close')" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
      </div>

      <!-- Modal de confirmación para cambiar estatus -->
      <v-dialog v-model="showStatusModal" max-width="800px" persistent>
        <v-card class="status-modal">
          <div class="warning-icon">
            <div class="warning-icon-outer">
              <div class="warning-icon-inner">
                <span class="warning-exclamation">!</span>
              </div>
            </div>
          </div>
          <div class="status-modal-content">
            <h2 class="status-modal-title">La conversión cambiará a estatus: CONCRETADA</h2>
            <p class="status-modal-description">
              Estás por marcar esta conversión como concretada. Esta acción no se puede deshacer.
            </p>
          </div>
          <div class="status-modal-actions">
            <v-btn
              outlined
              color="black"
              @click="showStatusModal = false"
              class="cancel-btn"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="black"
              class="white--text accept-btn"
              @click="confirmStatusChange"
              :loading="isChangingStatus"
            >
              Aceptar
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">
            Detalle de Conversión
          </div>
        </v-col>
      </v-row>

      <!-- Contenido principal -->
      <v-row class="ma-0" no-gutters>
        <v-col cols="12" class="pa-2">
          <div class="d-flex flex-wrap" style="gap: 16px;">
            <!-- ID de Conversión -->
            <div class="info-col" style="order: 1;">
              <v-card class="info-card mb-3">
                <div class="info-block mb-0">
                  <p class="label">ID:</p>
                  <p class="value">{{ isLoading ? '-' : (transaction.iTrackingId || '-') }}</p>
                </div>
              </v-card>
            </div>

            <!-- Columna izquierda - Detalles de transacción -->
            <div class="info-col" style="order: 2;">
              <v-card class="info-card mb-3">
                <div class="info-block mb-0">
                  <p class="label">Fecha de creación:</p>
                  <p class="value">{{ isLoading ? '-' : formatDate(transaction.created_at) }}</p>
                </div>
              </v-card>

              <v-card class="info-card mb-3">
                <div class="info-block mb-0">
                  <p class="label">Fecha de vencimiento:</p>
                  <p class="value">{{ isLoading ? '-' : (transaction.dForwardTransactionDate ? formatDate(transaction.dForwardTransactionDate) : '-') }}</p>
                </div>
              </v-card>

              <v-card class="info-card">
                <div class="info-block mb-0">
                  <p class="label">Tipo de transacción:</p>
                  <p v-if="isLoading" class="value">-</p>
                  <v-chip
                    v-else-if="transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'"
                    class="ma-0"
                    color="red"
                    outlined
                    style="background-color: #FDF0F5 !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Forward
                  </v-chip>
                  <v-chip
                    v-else-if="transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'"
                    class="ma-0"
                    color="#2397C7"
                    outlined
                    style="background-color: #F0F8FE !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    FOREX
                  </v-chip>
                  <v-chip
                    v-else-if="transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'"
                    class="ma-0"
                    color="#FB0075"
                    outlined
                    style="background-color: #FDEBEB !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Window spot
                  </v-chip>
                  <v-chip
                    v-else
                    class="ma-0"
                    color="orange"
                    outlined
                    style="background-color: #FDF8EB !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Pay now
                  </v-chip>
                </div>
              </v-card>
            </div>

            <!-- Columna central - Detalles financieros -->
            <div class="info-col" style="order: 4;">
              <v-card class="info-card mb-3">
                <div class="info-block mb-0">
                  <p class="label">Tipo de cambio:</p>
                  <p class="value">{{ isLoading ? '-' : `$ ${formatMoney(transaction.dExchangeRate < 1 ? 1 / transaction.dExchangeRate : transaction.dExchangeRate)} MXN` }}</p>
                </div>
              </v-card>

              <v-card class="info-card mb-3">
                <div class="info-block mb-0">
                  <p class="label">Monto origen:</p>
                  <p class="value">{{ isLoading ? '-' : `$ ${formatMoney(transaction.dAmount)} ${transaction.sCurrency || 'USD'}` }}</p>
                </div>
              </v-card>

              <v-card class="info-card">
                <div class="info-block mb-0">
                  <p class="label">Monto destino:</p>
                  <p class="value">{{ isLoading ? '-' : `$ ${formatMoney(transaction.dDesAmount)} ${transaction.sDestCurrency || 'MXN'}` }}</p>
                </div>
              </v-card>
            </div>

            <!-- Profit y Revenue -->
            <div class="info-col" style="order: 3;">
              <v-card class="info-card mb-3">
                <div class="info-block">
                  <p class="label">Currency Profit (USD):</p>
                  <p class="value" style="color: #0075B8;">{{ isLoading ? '-' : `$ ${formatMoney(transaction.dollarProfit || 0)} USD` }}</p>
                </div>
                <div class="info-block">
                  <p class="label">Currency Profit (%):</p>
                  <p class="value" style="color: #0075B8;">{{ isLoading ? '-' : `${formatMoney(transaction.percentProfit || 0)}%` }}</p>
                </div>
                <div class="info-block mb-0">
                  <p class="label">Revenue:</p>
                  <p class="value">-</p>
                </div>
              </v-card>
            </div>

            <!-- Columna derecha - Acciones y estado -->
            <div class="info-col pb-10" style="order: 5; padding: 32px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <!-- Botones de acción -->
              <div style="width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <v-btn
                  color="#000000"
                  elevation="8"
                  class="white--text mb-3"
                  block
                  disabled
                  style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none; max-width: 250px;"
                  @click="downloadDetails()"
                >
                  <v-icon class="mr-2" style="color: white;">mdi-download</v-icon>
                  Descargar
                </v-btn>
                <v-btn
                  color="#000000"
                  elevation="8"
                  class="white--text"
                  block
                  :disabled="transaction.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'"
                  style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none; max-width: 250px;"
                  @click="changeStatus()"
                >
                  <v-icon class="mr-2" style="color: white;">mdi-compare-horizontal</v-icon>
                  Cambiar estatus
                </v-btn>
              </div>

              <!-- Estado y Fresher coins -->
              <v-card class="info-card" style="margin-top: 32px; width: 100%; max-width: 300px;">
                <div class="info-block">
                  <p class="label">Fresher coins:</p>
                  <p class="value">-</p>
                </div>
                <div class="info-block mb-0">
                  <p class="label">Status:</p>
                  <p v-if="isLoading" class="value">-</p>
                  <v-chip
                    v-else-if="transaction.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227'"
                    class="ma-0"
                    color="green"
                    outlined
                    style="background-color: #F0F8F0 !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Concretada
                  </v-chip>
                  <v-chip
                    v-else-if="transaction.sStatusId == '679d409d-8fa9-404c-8fc7-9352e198c072'"
                    class="ma-0"
                    color="orange"
                    outlined
                    style="background-color: #FDF8EB !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Pendiente
                  </v-chip>
                  <v-chip
                    v-else-if="transaction.sStatusId == '4291b132-d28b-4b52-844a-77e4216857aa'"
                    class="ma-0"
                    color="blue"
                    outlined
                    style="background-color: #F0F8FE !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Finalizada
                  </v-chip>
                  <v-chip
                    v-else-if="transaction.sStatusId == '94bbc2b7-6e31-4523-b438-58c1987a907b'"
                    class="ma-0"
                    color="grey"
                    outlined
                    style="background-color: #F5F5F5 !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    Abierta
                  </v-chip>
                  <v-chip
                    v-else
                    class="ma-0"
                    color="grey"
                    outlined
                    style="background-color: #F5F5F5 !important; border-width: 1.5px; font-family: 'montserrat-medium';"
                  >
                    En proceso
                  </v-chip>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Tabla de Pagos Realizados -->
      <v-row class="ma-0 mt-8" v-if="!isLoading && transaction.payment && transaction.payment.length > 0">
        <v-col cols="12" class="pa-0">
          <div class="mb-4" style="font-family: 'montserrat-bold'; font-size: 26px; color: #000000;">
            Pagos Realizados
          </div>
          <v-data-table class="d-none d-sm-block" hide-default-header :items="transaction.payment">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">ID</th>
                  <th class="header__title center">Fecha de pago</th>
                  <th class="header__title center">Status</th>
                  <th class="header__title center">Proveedor</th>
                  <th class="header__title center">Monto USD</th>
                  <th class="header__title center">Monto MXN</th>
                  <th class="header__title center">Tipo de cambio</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.sPaymentId">
                  <td class="table__item">{{ item.payment.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.payment.created_at) }}</td>
                  <td class="table__item">
                    <v-chip
                      :color="getStatusColor(item.payment.status.sName)"
                      outlined
                      style="text-wrap: nowrap; white-space: normal;"
                    >
                      {{ item.payment.status.sName }}
                    </v-chip>
                  </td>
                  <td class="table__item">{{ item.payment.payment_recipient.sName + " - *" + (item.payment.payment_recipient.sAccountNumber || '').slice(-4) }}</td>
                  <td class="table__item">$ {{ formatMoney(item.dAmount / (transaction.dDesAmount / transaction.dAmount)) }} {{ transaction.sCurrency || 'USD' }}</td>
                  <td class="table__item">$ {{ formatMoney(item.dAmount) }} {{ transaction.sDestCurrency || 'MXN' }}</td>
                  <td class="table__item">$ {{ formatMoney(item.payment.dRate || (transaction.dDesAmount / transaction.dAmount)) }} MXN</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="$emit('go-to-payment', item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalle</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- Tabla de Facturas Aplicadas -->
      <v-row class="ma-0 mt-8" v-if="!isLoading && transaction.invoice && transaction.invoice.length > 0">
        <v-col cols="12" class="pa-0">
          <div class="mb-4" style="font-family: 'montserrat-bold'; font-size: 26px; color: #000000;">
            Facturas Aplicadas
          </div>
          <v-data-table class="d-none d-sm-block" hide-default-header :items="transaction.invoice">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">Factura</th>
                  <th class="header__title center">ID</th>
                  <th class="header__title center">Proveedor</th>
                  <th class="header__title center">Fecha de compra</th>
                  <th class="header__title center">Fecha de vencimiento</th>
                  <th class="header__title center">Cobertura de tasa</th>
                  <th class="header__title center">Monto USD</th>
                  <th class="header__title center">Monto MXN</th>
                  <th class="header__title center">Ganancia (USD)</th>
                  <th class="header__title center">Ganancia (%)</th>
                  <th class="header__title right">Acciones</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.sInvoiceId">
                  <td class="table__item">{{ item.invoice.sInvoice }}</td>
                  <td class="table__item">{{ item.invoice.sId }}</td>
                  <td class="table__item">{{ item.invoice.paymentsRecipent && item.invoice.paymentsRecipent[0] ? item.invoice.paymentsRecipent[0].sName + " - *" + item.invoice.paymentsRecipent[0].sAccountNumber.slice(-4) : '-' }}</td>
                  <td class="table__item">{{ formatDate(item.invoice.dPurchaseDate) }}</td>
                  <td class="table__item">{{ formatDate(item.invoice.dDueDate) }}</td>
                  <td class="table__item">$ {{ formatMoney(item.invoice.dRateProtection) }} MXN</td>
                  <td class="table__item">$ {{ formatMoney(item.dAmount / (transaction.dDesAmount / transaction.dAmount)) }} {{ transaction.sCurrency || 'USD' }}</td>
                  <td class="table__item">$ {{ formatMoney(item.dAmount) }} {{ transaction.sDestCurrency || 'MXN' }}</td>
                  <td class="table__item" style="color: #0075B8;">$ {{ formatMoney(item.dollarProfit || 0) }} USD</td>
                  <td class="table__item" style="color: #0075B8;">{{ formatMoney(item.percentProfit || 0) }}%</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="$emit('go-to-invoice', item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalle</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ConversionDetailContent",
  props: {
    sTransactionId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      transaction: {},
      isLoading: false,
      showStatusModal: false,
      isChangingStatus: false
    };
  },
  watch: {
    sTransactionId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getConversionDetail();
        }
      }
    }
  },
  methods: {
    getConversionDetail() {
      this.isLoading = true;
      const transactionId = this.sTransactionId;

      DB.get(`${URI}/api/v1/en/administrator/conversion/${transactionId}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.transaction = response.data.transaction;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    formatMoney: function (value) {
      if (!value) return "0.00";
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (!date) return "-";
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    getStatusColor(status) {
      const statusColors = {
        'COMPLETED': 'green',
        'DEPOSITED': 'green',
        'PENDING_TO_PROCESS': 'orange',
        'REJECTED': 'red',
        'PROCESSING': 'blue'
      };
      return statusColors[status] || 'grey';
    },
    downloadDetails() {
      // Implementar descarga de detalles
    },
    changeStatus() {
      this.showStatusModal = true;
    },
    async confirmStatusChange() {
      this.isChangingStatus = true;
      const transactionId = this.sTransactionId;

      try {
        const response = await DB.put(`${URI}/api/v1/en/administrator/conversion/${transactionId}/status`, {
          sStatusId: '5a792637-1103-4a89-8f67-86c49b93e227'
        }, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        if (response.data.success) {
          // Actualizar el estado local
          this.transaction.sStatusId = '5a792637-1103-4a89-8f67-86c49b93e227';
          this.showStatusModal = false;

          // Mostrar mensaje de éxito del backend
          this.mixSuccess(response.data.message);
        }
      } catch (error) {
        console.error('Error al cambiar status:', error);
        if (error.response?.data?.message) {
          this.mixError(error.response.data.message, error.response.status);
        } else {
          this.mixError('Error al cambiar el status de la conversión');
        }
      } finally {
        this.isChangingStatus = false;
      }
    },
  },
};
</script>

<style scoped>
.info-col {
  flex: 1 1 200px;
  min-width: 200px;
  max-width: 350px;
}

@media (max-width: 768px) {
  .info-col {
    flex: 1 1 100%;
    min-width: 100%;
    max-width: 100%;
  }
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px !important;
  padding: 16px;
}

.info-block {
  background-color: #F2F2F2;
  border-radius: 10px !important;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px 5px;
  width: fit-content;
  display: flex;
  align-items: center;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px 5px;
  margin-bottom: 2px;
  width: fit-content;
  display: flex;
  align-items: center;
}

/* Estilos para el modal de cambio de estatus */
.status-modal {
  border-radius: 20px !important;
  background-color: #fff;
  overflow: hidden;
  padding: 0;
}

.warning-icon {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
  margin-bottom: -40px;
}

.status-modal-content {
  background-color: #000;
  color: white;
  text-align: center;
  padding: 50px 40px 40px 40px;
  margin: 50px 40px 40px 40px;
  border-radius: 15px;
}

.warning-icon-outer {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #333;
  border: 3px solid #666;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 20px;
}

.warning-icon-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-exclamation {
  color: white;
  font-size: 36px;
  font-weight: bold;
  font-family: Arial, sans-serif;
}

.status-modal-title {
  font-family: 'montserrat-bold';
  font-size: 22px;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: 700;
}

.status-modal-description {
  font-family: 'montserrat-medium';
  font-size: 16px;
  line-height: 1.4;
  opacity: 0.95;
  margin: 0;
}

.status-modal-actions {
  background-color: white;
  padding: 20px 30px 30px 30px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.cancel-btn {
  width: 120px;
  border-radius: 36px !important;
  border: 2px solid #000000 !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}

.accept-btn {
  width: 120px;
  border-radius: 36px !important;
  font-family: 'montserrat-semibold' !important;
  text-transform: none !important;
  height: 42px;
  font-weight: 600;
  font-size: 14px;
}
</style>
